import { localStorageService } from "../../services/localStorageService";
import {
    branchLoadingLatestReleaseStorageKey,
    branchLoadingStorageKey,
    branchStorageKey,
    mobileUiInNativeWrapperStorageKey
} from "../../types/startupConstants";
import { getBase, loadScript, loadStyle } from "./utils/loaderUtils";

const loadScripts = async () => {
    const head = document.getElementsByTagName("head")[0];
    let branch = localStorageService.getItem(branchLoadingStorageKey);
    const isMobileUIInNativeWrapper = localStorageService.getItem(mobileUiInNativeWrapperStorageKey);

    if (branch != null) {
        branch = getBase() + branch;

        const latestRelease = localStorageService.getItem(branchLoadingLatestReleaseStorageKey);
        const preprodBranch = localStorage.getItem(branchStorageKey);
        let cacheBuster = latestRelease;

        if (preprodBranch) {
            cacheBuster = Date.now().toString(); // Force latest version if using a preprod branch.
        }

        if (!isMobileUIInNativeWrapper) {
            loadScript(`${branch}/static/js/desktopOverride.js?v=${cacheBuster}`, head);
        }
        loadStyle(`${branch}/static/css/main.css?v=${cacheBuster}`, head);
        loadScript(`${branch}/static/js/main.js?v=${cacheBuster}`, head);

        localStorageService.clearItem(branchLoadingStorageKey);
        localStorageService.clearItem(branchLoadingLatestReleaseStorageKey);
    } else {
        const base = getBase();

        // Increase version number if desktopOveride or releaseSelector changes.
        if (!isMobileUIInNativeWrapper) {
            loadScript(`${base}/static/js/desktopOverride.js?v=10`, head);
        }
        loadScript(`${base}/static/js/releaseSelector.js?v=10`, head);
    }
};

(async function () {
    await loadScripts();

    window.lmsMobileLoaderAvailable = true;
})();
